<template>
  <tooltip
    v-if="!!linksClicked?.length || $slots.default"
    ref="linksTooltip"
    placement="top-start"
    sticky="reference"
    max-width="450"
    :arrow="false"
    :popper-options="popperOptions"
    class="translate-y-0-25 transform"
  >
    <icon-base
      :icon="IconLink"
      width="18"
      height="18"
      view-box="0 0 24 24"
      class="rotate-90 transform"
    />
    <template #content>
      <slot>
        <div class="flex flex-col space-y-1">
          <span class="text-xs font-medium text-label">
            {{ $t("EMAIL_INTEGRATION.LINKS_CLICKED").toLowerCase() }}:
          </span>
          <div
            v-for="link in linksClicked"
            :key="link.link"
            class="max-w-200 truncate text-xxs text-white/80"
          >
            <span class="text-white">
              {{
                formatDateCustom(link.timestamp, "MMM dd, yyyy hh:mm a", true)
              }}
            </span>
            {{ link.link }}
          </div>
        </div>
      </slot>
    </template>
  </tooltip>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { formatDateCustom } from "@/helpers/formatting";

import IconLink from "@/components/icons/IconLink.vue";

import type { EmailLinksClicked } from "@/models/communicationLogs";
import type { TippyComponent } from "vue-tippy";

interface Props {
  linksClicked?: EmailLinksClicked[];
}

defineProps<Props>();

const linksTooltip = ref<TippyComponent | null>(null);
const popperOptions = ref<TippyComponent["popperOptions"]>({
  modifiers: [
    {
      name: "flip",
      options: { fallbackPlacements: ["bottom", "top"] },
    },
  ],
});
</script>
